// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "cafe4dfa3423306bf1ee" + "-11.10.3-9ae3400-202504150826.js";
};